export default __webpack_public_path__ + "static/media/105.b924b43c.jpg";